<template>
    <div
        v-bind:id="[showList ? 'miei-ordini' : 'ordine']"
        class="bg-light"
    >
        <div class="body-wrapper">
            <gallery-header />
            <main v-show="showList">
                <div class="container-fluid mt-5">
                    <div class="row d-flex justify-content-between flex-wrap align-items-center">
                        <div class="col-sm-8">
                            <h2 class="mb-0 text-uppercase">{{$t('I miei ordini')}}</h2>
                        </div>
                    </div>

                    <table class="elenco-ordini tabella-responsive table table-striped mt-3 mb-0">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    class="px-1"
                                ><a href="#">{{$t('Ordine')}} # <i class="fas fa-caret-down"></i>
                                        <!--<i class="fas fa-caret-up"></i>-->
                                    </a></th>
                                <th
                                    scope="col"
                                    class="px-1"
                                ><a href="#">{{$t('Data')}}</a></th>
                                <th
                                    scope="col"
                                    class="px-1"
                                ><a href="#">{{$t('Gallery')}}</a></th>
                                <th
                                    scope="col"
                                    class="px-1"
                                ><a href="#">{{$t('Status')}}</a></th>
                                <th
                                    scope="col"
                                    class="px-1"
                                ><a href="#">{{$t('Totale')}}</a></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                class="ordine mt-0"
                                v-for="(order) in orders"
                                v-bind:key="order.id"
                            >
                                <td
                                    data-title="Ordine #"
                                    class="num align-middle px-1"
                                >
                                    <span class="num-ordine">
                                        <a
                                            href="javascript:void(0)"
                                            @click="showOrderDetail(order.id)"
                                        >{{order.num}}</a>
                                    </span>
                                </td>
                                <td
                                    data-title="Data"
                                    class="align-middle px-1"
                                >
                                    <span class="data-ordine">{{order.creationDate | formatDate}}</span>
                                </td>
                                <td
                                    data-title="Gallery"
                                    class="align-middle px-1"
                                >
                                    <span class="titolo-gallery">{{order.eventTitle}}</span>
                                </td>
                                <td
                                    data-title="Status"
                                    class="align-middle px-1"
                                >
                                    <span
                                        v-if="order.status === '0'"
                                        class="status"
                                    >{{$t('Da elaborare')}}</span>
                                    <span
                                        v-if="['2', '3', '4', '5'].includes(order.status)"
                                        class="status"
                                    >{{$t('In stampa')}}</span>
                                    <span
                                        v-if="order.status === '6'"
                                        class="status"
                                    >{{$t('Spedito')}}</span>
                                    <span
                                        v-if="order.status === '7'"
                                        class="status"
                                    >{{$t('Consegnato')}}</span>
                                    <span
                                        v-if="order.status === '8'"
                                        class="status"
                                    >{{$t('Annullato')}}</span>
                                    <span
                                        v-if="['V', 'P'].includes(order.status)"
                                        class="status"
                                    >{{$t('Da pagare')}}</span>
                                    &nbsp;
                                    <b-button-group>
                                        <b-button
                                            variant="success"
                                            class="ml-2"
                                            v-if="order.status === 'P'"
                                            @click="payOrder(order)"
                                        >
                                            {{$t('Paga')}}
                                        </b-button>

                                        <orders-cancel-order :order="order" :activationDate="activationDate" @cancelOrder="cancelOrder"/>
                                    </b-button-group>
                                </td>
                                <td
                                    data-title="Totale"
                                    class="align-middle px-1"
                                >
                                    <span class="totale font-weight-bold">{{order.total}} €</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <form
                    ref="paypalForm"
                    action=""
                    method="post"
                    target="_top"
                >
                    <input
                        type="hidden"
                        name="cmd"
                        value="_xclick"
                    >
                    <input
                        type="hidden"
                        name="business"
                        value=""
                    >
                    <input
                        type="hidden"
                        name="lc"
                        value="IT"
                    >
                    <input
                        type="hidden"
                        name="item_name"
                        value="form key"
                    >
                    <input
                        type="hidden"
                        name="amount"
                        value="0"
                    >
                    <input
                        type="hidden"
                        name="currency_code"
                        value="EUR"
                    >
                    <input
                        type="hidden"
                        name="button_subtype"
                        value="services"
                    >
                    <input
                        type="hidden"
                        name="no_note"
                        value="0"
                    >
                    <input
                        type="hidden"
                        name="bn"
                        value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
                    >
                    <input
                        type="hidden"
                        name="return"
                        value=""
                    >
                    <input
                        type="hidden"
                        name="cancel_return"
                        value=""
                    >
                    <input
                        type="hidden"
                        name="item_number"
                        value=""
                    >
                    <input
                        type="hidden"
                        name="notify_url"
                        value=""
                    >
                    <input
                        type="hidden"
                        name="custom"
                        value="this is the custom variable. it is named 'cm' in the returned Url."
                    >
                    <input
                        type="hidden"
                        name="rm"
                        value="1"
                    >
                    <input
                        type="hidden"
                        name="cbt"
                        value="Return to Merchant"
                    >
                    <img
                        src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                        alt=""
                        width="1"
                        height="1"
                        border="0"
                    >
                </form>
            </main>
            <account-detail
                v-show="showDetail"
                v-bind:order="orderDetail"
                @showOrdersList="showOrdersList"
            />
            <gallery-footer />
        </div>
    </div>
</template>

<script>
    import AccountDetail from "./Detail";
    import GalleryFooter from "../../components/gallery/Footer";
    import GalleryHeader from "../../components/gallery/Header";
    import OrdersCancelOrder from "../../components/account/OrdersCancelOrder";

    export default {
        name: "AccountOrders",
        components: {AccountDetail, GalleryHeader, GalleryFooter, OrdersCancelOrder},

        data() {
            return {
                orders: [],
                activationDate: "",
                timeRemainingList: [],
                orderDetail: {},
                showDetail: false,
                showList: true
            };
        },

        mounted() {
            this.$api
                .getOrders()
                .then((result) => {
                    console.debug("GET_ORDERS", result);
                    this.orders = result.orders;
                    this.activationDate = result.activationDate;
                })
                .catch(error => {
                    console.error("GET_ORDERS", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },

        methods: {
            showOrderDetail(orderId) {
                this.orderDetail = this.orders.filter(
                    (item) => item.id === orderId
                );
                this.orderDetail = this.orderDetail[0];
                this.showList = false;
                this.showDetail = true;
            },

            showOrdersList() {
                this.showDetail = false;
                this.showList = true;
            },

            payOrder(order) {
                if (order.paypalData) {
                    this.$refs.paypalForm.action =
                        process.env.VUE_APP_PAYPAL_ENDPOINT;
                    this.$refs.paypalForm.business.value =
                        order.paypalData.accountEmail;
                    this.$refs.paypalForm.amount.value = order.total;

                    this.$refs.paypalForm.return.value =
                        window.location.origin +
                        this.$router.resolve({
                            name: "gallery-order-confirm",
                            params: {
                                galleryUrl: this.$route.params.galleryUrl,
                                orderId: order.id
                            }
                        }).href;
                    this.$refs.paypalForm.cancel_return.value = window.location.origin + this.$router.resolve({name: "gallery-account-orders"}).href;
                    this.$refs.paypalForm.notify_url.value = order.paypalData.notifyUrl;
                    this.$refs.paypalForm.item_number.value = order.paypalData.itemNumber;
                    this.$refs.paypalForm.submit();
                }
            },

            cancelOrder(order) {
                if (order) {
                    this.$api
                        .cancelOrder(order.id)
                        .then((result) => {
                            if (result.canceled) {
                                window.location.reload();
                            }
                        })
                        .catch((error) => {
                            console.error("CANCEL_ORDER", error);
                            this.$router.push({
                                name: this.$route.meta.gotoOnAuthFailed,
                                params: this.$route.params
                            });
                        });
                }
            }
        }
    }
</script>

<style scoped>
</style>
